import React, { useState, useEffect } from 'react';
import { noticeService } from '../../services/api';
import toast from 'react-hot-toast';

const Notices = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchNotices();
  }, []);

  const fetchNotices = async () => {
    try {
      const response = await noticeService.getAll();
      setNotices(response.data.data || []);
    } catch (error) {
      console.error('Error fetching notices:', error);
      toast.error('Failed to load notices');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Notices</h1>
      <div className="space-y-4">
        {notices.length === 0 ? (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center text-gray-500">
            No notices available
          </div>
        ) : (
          notices.map((notice, index) => (
            <div key={notice._id || index} className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition">
              <div className="flex justify-between items-start">
                <h3 className="text-lg font-semibold text-gray-800">{notice.title}</h3>
                {notice.type && (
                  <span className={`px-2 py-1 rounded-full text-xs ${
                    notice.type === 'Holiday' ? 'bg-red-100 text-red-800' :
                    notice.type === 'Meeting' ? 'bg-blue-100 text-blue-800' :
                    'bg-green-100 text-green-800'
                  }`}>
                    {notice.type}
                  </span>
                )}
              </div>
              <p className="text-gray-600 mt-2">{notice.content || notice.description}</p>
              <p className="text-sm text-gray-400 mt-3">
                {notice.date ? new Date(notice.date).toLocaleDateString() : 'Recently'}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Notices;
